import { toBig } from '@talos/kyoko';

interface GetSizeCounteredLegQtyParams {
  topLevelQty: string | undefined;
  sizeRatio: string | undefined;
}

export function getSizeCounteredLegQty({ topLevelQty, sizeRatio }: GetSizeCounteredLegQtyParams): string | undefined {
  const qty = toBig(topLevelQty);
  const ratio = toBig(sizeRatio);

  if (!qty || !ratio) {
    return undefined;
  }

  return ratio.times(qty).toFixed();
}
